import { render, staticRenderFns } from "./keycloak-callback.vue?vue&type=template&id=2f003fec"
import script from "./keycloak-callback.vue?vue&type=script&lang=js"
export * from "./keycloak-callback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports